import { AlarmStatus } from "./alarmstatus";

export class Device {
	Id: string;
	Name: string;
	AlarmStatus: AlarmStatus;
	Status: boolean;
	CareHomeName: string;
	CareHomeId: string;
	ResidentName: string;
	SecondsSinceLastMessage: number;
	SecondsDelay: number;
	MaxSecondsDelay: number;
	ConfigVersion: number;
	ConfigFetchedAt?: Date;
	DeviceConfig: any;
	FirmwareVersion?: string;
}

export class DeviceSyncStatus {
	Id: string;
	SerialNumber: string;
	FirmwareVersion: string;
	SyncStatus: DeviceSyncStatusValue;
}

export enum DeviceSyncStatusValue {
	Synced,
	OutOfSync
}
